import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/*! Provides core utilities for the working with both versions of the ESRI JSAPI.
 *
 * @ai360/core v33.1.0 (https://bitbucket.org/agvanceskyteam/ai360.client.core.git)
 * SSI DO NOT COPY!!!
 */
import { H as t } from "./history-manager.js";
import { L as e } from "./utils/auto-pan.js";
import "./symbols.js";
import "@arcgis/core/symbols/support/jsonUtils";
import "@arcgis/core/renderers/support/jsonUtils";
import "./utils/map.js";
import "@arcgis/core/Graphic";
import "@arcgis/core/geometry/Geometry";
import "./index.js";
import "./zone-classification.js";
import "@arcgis/core/geometry/Polygon";
import "@arcgis/core/geometry/geometryEngine";
import "./api/rec.js";
import "uuid";
import "@arcgis/core/geometry/SpatialReference";
import "@arcgis/core/tasks/Locator";
import "@arcgis/core/geometry/support/webMercatorUtils";
import "@arcgis/core/geometry/support/jsonUtils";
import "@arcgis/core/geometry/projection";
import "@terraformer/arcgis";
import "lodash";
import { b as o } from "./geometry/utils.js";
import "@arcgis/core/Basemap";
import "./enums.js";
import "./geometry/creator.js";

var ExtentTools = /*#__PURE__*/function () {
  function ExtentTools(o, s) {
    var _this = this;

    _classCallCheck(this, ExtentTools);

    this.history = new t(), this.listeners = new e(), this.isInitialZoomComplete = !1, this.map = o, this.options = s, this.map.when(function () {
      _this.map.watch("stationary", function (t, e) {
        1 == t && (_this.isInitialZoomComplete && _this._checkExtent(), _this.isInitialZoomComplete = !0);
      }), _this._forceUpdate();
    }), this.listeners.add(this.history.on("state-change", function (t) {
      return _this.applyExtent(t);
    }));
  }

  _createClass(ExtentTools, [{
    key: "previous",
    value: function previous() {
      this.history.undo();
    }
  }, {
    key: "next",
    value: function next() {
      this.history.redo();
    }
  }, {
    key: "full",
    value: function full() {
      this.map.goTo(this.history.getState(0));
    }
  }, {
    key: "applyExtent",
    value: function applyExtent(t) {
      this.extentUpdateIsHistoryUpdate = !0, this.map.goTo(t);
    }
  }, {
    key: "_checkExtent",
    value: function _checkExtent() {
      if (this.history.getLength() > 0) {
        if (this.extentUpdateIsHistoryUpdate) return this.extentUpdateIsHistoryUpdate = !1, void this._forceUpdate();
        if (o.areExtentsEqual(this.history.getCurrentState(), this.map.extent)) return;
      }

      this.history.add(this.map.extent), this._forceUpdate();
    }
  }, {
    key: "_forceUpdate",
    value: function _forceUpdate() {
      this.options.forceUpdate && this.options.forceUpdate();
    }
  }, {
    key: "destroy",
    value: function destroy() {
      var _this2 = this;

      this.listeners.removeAll(), Object.keys(this).forEach(function (t) {
        _this2[t] = null;
      });
    }
  }, {
    key: "getDimensions",
    value: function getDimensions() {
      return {
        top: 0,
        left: 0,
        width: 220,
        height: 51
      };
    }
  }]);

  return ExtentTools;
}();

export { ExtentTools as E };